export interface PollConfig<T> {
    api: () => Promise<T>;
    interval: number;
    onError?: (error: unknown) => void;
}

export interface PollEntry<T> {
    config: PollConfig<T>;
    timerId: ReturnType<typeof setTimeout> | undefined;
    running: boolean;
}

export interface PollResult<T> {
    data?: T;
    error?: unknown;
    timestamp: number;
}

export enum PollKey {
    WIFI_STATUS = 'wifi-status',
}